/* @flow */

export const COUNTRIES_WITH_STATES = ['US', 'CA', 'AU', 'BR'];
